// extracted by css-extract-rspack-plugin
export default {"table":"Table_table__usrej"};